import { checkType } from '../checkType/checkType';
/**
 * Checks whether an object has a specific property or a nested property path.
 *
 * @template T - The type of the object to check.
 * @template K - The key or array of keys representing the property path.
 * @param obj - The object to check.
 * @param key - The property key or an array of keys representing a nested property path.
 * @param defaultValue - The default boolean value to return if checks fail.
 * @returns `true` if the property exists, otherwise the `defaultValue`.
 */
export var hasOwnProperty = function (obj, key, defaultValue) {
    if (defaultValue === void 0) { defaultValue = false; }
    if (obj === null || obj === undefined) {
        return defaultValue;
    }
    if (checkType(obj, 'object') && checkType(key, 'string')) {
        return Object.prototype.hasOwnProperty.call(obj, key);
    }
    if (checkType(key, 'array')) {
        var keys = key;
        var current = obj;
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var prop = keys_1[_i];
            if (checkType(current, 'object')) {
                current = current[prop];
            }
            else {
                current = undefined;
                break;
            }
        }
        return current !== undefined && current !== null ? true : defaultValue;
    }
    return defaultValue;
};
